import CSS from './Survey.module.css';
import type { SurveyStep } from '@/routes/Onboarding/types.d';
import CheckmarkIcon from '@/assets/images/check-mark.svg?react';

type SurveyProps = {
  step: SurveyStep;
  selected: string[];
  translations: Record<string, string>;
  onToggle: (key: string) => void;
};

const Survey = ({
  step,
  selected,
  translations,
  onToggle,
}: SurveyProps) => (
  <div className={CSS.surveyStep}>
    <h1 className={CSS.question}>{translations[step.questionKey]}</h1>
    <ul className={CSS.options}>
      {step.optionKeys.map((key: string) => (
        <li key={key}>
          <button
            role="option"
            type="button"
            className={`${CSS.option} ${selected.includes(key) ? CSS.optionSelected : CSS.optionUnselected}`}
            onClick={() => onToggle(key)}
            aria-pressed={selected.includes(key)}
          >
            {selected.includes(key) && <CheckmarkIcon className={CSS.checkmark} />}
            {translations[key]}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

export default Survey;
